export default function EyeMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1816)">
                <rect width="100%" height="100%" fill="#FF89C2" />
                <path d="M999.904 0H0.0429688V999.861H999.904V0Z" fill="#1C5DCC" />
                <path d="M499.973 999.861C776.077 999.861 999.904 776.034 999.904 499.931C999.904 223.827 776.077 0 499.973 0C223.869 0 0.0429688 223.827 0.0429688 499.931C0.0429688 776.034 223.869 999.861 499.973 999.861Z" fill="#FF89C2" />
                <path d="M499.97 229.235C290.693 229.235 106.572 336.94 0 499.931C106.572 662.922 290.693 770.627 499.97 770.627C709.248 770.627 893.369 662.922 999.94 499.931C893.369 336.94 709.248 229.235 499.97 229.235Z" fill="white" />
                <path d="M499.599 295C386.601 295 295 386.601 295 499.598C295 612.596 386.601 704.196 499.599 704.196C612.596 704.196 704.197 612.596 704.197 499.598C704.197 386.601 612.596 295 499.599 295ZM499.599 596.638C446.006 596.638 402.572 553.191 402.572 499.612C402.572 446.032 446.019 402.585 499.599 402.585C553.178 402.585 596.625 446.032 596.625 499.612C596.625 553.191 553.178 596.638 499.599 596.638Z" fill="#01B4EE" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1816">
                    <rect width="100%" height="100%" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}